module.exports = __webpack_public_path__ + "static/img/c201.45e7d38b.png";